import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { language, changeLanguage, availableLanguages } = useLanguage();

  return (
    <div className="relative group">
      <button
        className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 hover:text-amber-800 transition-colors"
        aria-label="Change language"
      >
        <Globe className="w-4 h-4" />
        <span className="hidden sm:inline">
          {availableLanguages.find(lang => lang.code === language)?.name || 'English'}
        </span>
      </button>

      {/* Dropdown */}
      <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
        {availableLanguages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => !lang.disabled && changeLanguage(lang.code)}
            disabled={lang.disabled}
            className={`w-full text-left px-4 py-3 text-sm flex items-center gap-3 hover:bg-gray-50 first:rounded-t-lg last:rounded-b-lg transition-colors ${
              language === lang.code ? 'bg-amber-50 text-amber-800 font-medium' : 'text-gray-700'
            } ${lang.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
          >
            <span className="text-xl">{lang.flag}</span>
            <span className="flex-1">{lang.name}</span>
            {lang.disabled && (
              <span className="text-xs text-gray-400">(Coming Soon)</span>
            )}
            {language === lang.code && !lang.disabled && (
              <span className="text-amber-600">✓</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;




